import React, { useEffect, useRef, useState } from "react";

const Cursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    let dotX = 0,
      dotY = 0,
      ringX = 0,
      ringY = 0,
      tx = 0,
      ty = 0;
    let rafId;

    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;
    };

    const animate = () => {
      dotX += (tx - dotX) * 0.9;
      dotY += (ty - dotY) * 0.9;
      ringX += (tx - ringX) * 0.15;
      ringY += (ty - ringY) * 0.15;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${dotX}px, ${dotY}px) translate(-50%,-50%)`;
      }
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%,-50%)`;
      }
      rafId = requestAnimationFrame(animate);
    };

    const onOver = (e) => {
      const target = e.target;
      if (target.closest?.("a, button, [data-cursor='hover'], input, [role='button']")) {
        setHovered(true);
      } else {
        setHovered(false);
      }
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    animate();
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="cursor-dot" />
      <div ref={ringRef} className={`cursor-ring ${hovered ? "hovered" : ""}`} />
    </>
  );
};

export default Cursor;
